/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Care_Log_ParcelsInputs */

const vi_trace_care_log_parcels = /** @type {(inputs: Trace_Care_Log_ParcelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô/thửa`)
};

/**

* @param {Trace_Care_Log_ParcelsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_care_log_parcels = /** @type {((inputs?: Trace_Care_Log_ParcelsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Care_Log_ParcelsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_care_log_parcels(inputs)
});